
import { SearchableSelect } from "../../ui/SearchableSelectReact";

import { diligenceObservable } from "../../../observers/deligenceObservable";
import React, { useState, useMemo, useCallback } from "react";
import { Input } from "../../ui/Input";
import { Select } from "../../ui/Select";
// import {select} from "../../ui/Selectelect";
// import { SelectCountry } from "../../ui/SelectCountry";  // ✅ Import added
import { SelectCountry } from "../../selectors/country/selectCountry";
import { RadioGroup } from "../../ui/RadioGroup";
import useCountries from "../../../hooks/useCountries";

import useDeligenceStatus from "../../../hooks/useDeligenceStatus";

import { CountryRiskPopup } from "../../popups/countryRiskPopup";
import { yesNoOption } from "../../options/options";


export const IndividualForm = React.memo(({formData, onChange, isReadOnly, isReport}) => {


    
const countries = useCountries();
const { getDeligenceStatusByCountry } = useDeligenceStatus();
const ownerId = useMemo(() => "manager"  + "Individual");
const [showPopup, setShowPopup] = useState(false);

    const handleNationalityChange = useCallback(async (event) => {
        diligenceObservable.remove(ownerId);
        const selectedCountry = event.target.value;
        const name = event.target.name;
        if (selectedCountry !== "None") {
            const response = await getDeligenceStatusByCountry(selectedCountry);
            if (response) {
                const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
                if (hasEnhanced) {
                    setShowPopup(true);
                }
            }
        }
        let privateEvent = { target: { name: name, value: selectedCountry } };
        onChange(privateEvent);
    }, [getDeligenceStatusByCountry, onChange, ownerId]);
    return (
        <>
            <Input 
                label={"Full Name"}
                name={"fullName"}
                value={formData.fullName}
                disabled={isReadOnly}
                onChange={onChange}
                placeholder={"First Name, Last Name"}
                isReport={isReport}
            />

              <SelectCountry
                            label={"Nationality"}
                            name={"nationality"}
                            disabled={isReadOnly}
                            value={formData.nationality}
                            onChange={handleNationalityChange}
                            isReport={isReport}
                            options={countries.map((value) => ({ value, display_value: value }))}
                        />



              <SelectCountry
                            label={"Country of Residence"}
                            name={"countryOfResidence"}
                            required
                            disabled={isReadOnly}
                            value={formData.countryOfResidence}
                          
                            onChange={handleNationalityChange}
                            isReport={isReport}
                        />

    
            <Input
                type="date"
                label={"Date of Birth"}
                name={"dateOfBirth"}
                disabled={isReadOnly}
                value={formData.dateOfBirth}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Address Line 1"}
                required={true}
                name={"addressLine1"}
                disabled={isReadOnly}
                value={formData.addressLine1}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Address Line 2"}
                name={"addressLine2"}
                disabled={isReadOnly}
                value={formData.addressLine2}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Address Line 3"}
                name={"addressLine3"}
                disabled={isReadOnly}
                value={formData.addressLine3}
                onChange={onChange}
                isReport={isReport}
            />

    

            <Input 
                label={"City"}
                required={true}
                name={"city"}
                disabled={isReadOnly}
                value={formData.city}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"County/State"}
                name={"state"}
                disabled={isReadOnly}
                value={formData.state}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Postal Code"}
                required={true}
                name={"postalCode"}
                disabled={isReadOnly}
                value={formData.postalCode}
                onChange={onChange}
                isReport={isReport}
            />
               <SelectCountry
                            name={"country"}
                            required={true}
                            label={"Country"}                        
                            disabled={isReadOnly}
                            value={formData.country}
                            onChange={handleNationalityChange}
                            isReport={isReport}
                        />




            {/* <SearchableSelect
                label={"Country"}
                required={true}
                name={"country"}
                disabled={isReadOnly}
                value={formData.country}
                onChange={onChange}
                isReport={isReport}
            /> */}

        </>
    );
})